import DescRegistroService from 'src/modules/descRegistro/descRegistroService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'DESCREGISTRO_FORM';

const descRegistroFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: descRegistroFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await DescRegistroService.find(id);
      }

      dispatch({
        type: descRegistroFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: descRegistroFormActions.INIT_ERROR,
      });

      getHistory().push('/desc-registro');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: descRegistroFormActions.CREATE_STARTED,
      });

      await DescRegistroService.create(values);

      dispatch({
        type: descRegistroFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.descRegistro.create.success'),
      );

      getHistory().push('/desc-registro');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: descRegistroFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: descRegistroFormActions.UPDATE_STARTED,
      });

      await DescRegistroService.update(id, values);

      dispatch({
        type: descRegistroFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.descRegistro.update.success'),
      );

      getHistory().push('/desc-registro');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: descRegistroFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default descRegistroFormActions;
